const Notifications = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M10.2221 20.6666C10.335 21.0512 10.5695 21.3889 10.8903 21.6292C11.2112 21.8694 11.6013 21.9992 12.0021 21.9992C12.4029 21.9992 12.793 21.8694 13.1139 21.6292C13.4348 21.3889 13.6692 21.0512 13.7821 20.6666"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12 4V2"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
      <path
        d="M12 4C13.7681 4 15.4638 4.70238 16.714 5.95262C17.9643 7.20286 18.6667 8.89856 18.6667 10.6667C18.6667 16.9298 20 18 20 18H4C4 18 5.33333 16.2969 5.33333 10.6667C5.33333 8.89856 6.03571 7.20286 7.28595 5.95262C8.5362 4.70238 10.2319 4 12 4V4Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Notifications;
